import React from 'react';

const ShapingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg 
    id="Calque_1" 
    data-name="Calque 1" 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 9.21 8.14"
    {...props}
  >
    <defs>
      <style>
        {`.cls-1{fill:currentColor;}.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1px;}`}
      </style>
    </defs>
    <title>Shaping Icon</title>
    <path 
      className="cls-1" 
      d="M129.72,310.23c2,0,3.6.86,3.75,2.14s-1.56,2.81-3.86,3.07-4.29-.67-4.46-2.1c-.15-1.23,1.13-2.43,3-2.91a2,2,0,0,1,.82.88,6.26,6.26,0,0,1,.36,1.79,2.46,2.46,0,0,0,.7-1.84c-.14-1.06-.29-1-.29-1Z" 
      transform="translate(-125.14 -310.23)"
    />
    <path 
      className="cls-2" 
      d="M134.05,316.27a6.94,6.94,0,0,1-4,1.66,6.78,6.78,0,0,1-4.47-.85"
      transform="translate(-125.14 -310.23)"
      strokeWidth="0.6"
    />
    <polygon 
      className="cls-1" 
      points="6.78 5.56 6.75 5.96 8.75 6.1 8.47 8.08 8.87 8.14 9.21 5.72 6.78 5.56"
    />
  </svg>
);

export default ShapingIcon;